import * as actionTypes from "../constants";

const initialState = {
  loading: true,
  error: null,
  forms: [],
  saving: false,
  saved: false,
};

export default function behaviouralForm(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FETCH_BEHAVIOURAL_FORMS:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.GET_BEHAVIOURAL_FORMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        forms: payload,
      };

    case actionTypes.GET_BEHAVIOURAL_FORMS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case actionTypes.SAVING_BEHAVIOURAL_FORM:
      return {
        ...state,
        saving: true,
        saved: false,
      };

    case actionTypes.SAVE_BEHAVIOURAL_FORM_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case actionTypes.SAVE_BEHAVIOURAL_FORM_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        error: payload,
      };

    default:
      return state;
  }
}
